module.exports = __webpack_public_path__ + "img/invite_bg.60cb17f0.png";